import React from 'react';
import PropTypes from 'prop-types';

const LikesUser = ({ user }) => (
  <div className="user-item">
    {(user.user && user.user.avatar_url) ? (
      <div className="user-avatar">
        <img src={user.user.avatar_url} alt={user.name} className="avatar avatar-40" />
      </div>
    ) : (
      <div className={`avatar avatar-40 icon-avatar user-avatar ${!user.user ? 'light-' : ''}gray`}>
        <i className={`fas fa-${!user.user ? 'at' : 'user'}`} />
      </div>
    )}
    <div className="user-item-body">
      <h6 className="user-item-title">
        {user.name}
      </h6>
      {user.user && (
        <span className="user-item-details">
          {user.user.email}
        </span>
      )}
    </div>
  </div>
);

LikesUser.propTypes = {
  user: PropTypes.object.isRequired,
};

export default LikesUser;
